var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zone-card"},[_c('p',{staticClass:"zone-result__label"},[_vm._v(" "+_vm._s(_vm.zone.TMName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }